import { ApiService } from "../..";

export const uploadVoice = (sampleId: string, form: any) => {
  return ApiService.baseAction(
    `voice/upload/${sampleId}`,
    {
      data: form,
    },
    "post"
  );
};
